// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__1py-W","header":"card_header__7VIdU","content":"card_content__3skpd","body":"card_body__2TKu0"};